import React from 'react'
import { FiHome } from 'react-icons/fi';
import { SlHome } from "react-icons/sl";

const FooterBreadCrumb = ({ heading }) => {

    return (
        <>
            {/* Page Header */}
            <div className={`page-header`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item active">{heading}</span>
                </div>

            </div>
        </>
    )
};

export default FooterBreadCrumb;




